import GuideConfirmationDialog from "./confirmation-dialog";

const GuideSectionDeleteDialog = ({ id, onCancel, onDelete }) => (
  <GuideConfirmationDialog
    id={id}
    title="Delete Tab"
    confirmLabel="Delete"
    closeLabel="Close delete confirmation"
    onCancel={onCancel}
    onConfirm={onDelete}
  >
    <p>
      Are you sure you want to delete?{" "}
      <b>Warning: This step cannot be reversed.</b>
    </p>
  </GuideConfirmationDialog>
);

export default GuideSectionDeleteDialog;
